<template>
    <div class="code-input">
        <van-popup v-model="popupShow" :close-on-click-overlay="false" class="popup">

            <div class="form">
                <div class="close-btn">
                    <van-icon name="cross" @click="popupShow=false" />
                </div>

                <div class="title">请输入验证码</div>
                <div class="tips">短信验证码已发送至尾号***{{phone.slice(7,11)}}</div>

                <van-password-input :value="code" :gutter="10" :focused="showKeyboard" @focus="showKeyboard = true" :mask="false"/>
                <van-number-keyboard v-model="code" :show="showKeyboard" @blur="showKeyboard = false" />

                <div class="btn-wrap">

                    <div class="btn" @click="onSubmit">
                        <span>确定</span>
                    </div>
                </div>

            </div>

        </van-popup>

    </div>
</template>

<script>
import { Popup, PasswordInput, NumberKeyboard } from "vant";
import {
    checkCarStatus,
    getCarCoupon,
    getCarInfo,
    robCarCoupon,
    checkUserIsReal,
    getVerCode,
    realUserInfo,
} from "@/api/index";
export default {
    name: "PasswardForm",
    props: {
        phone: String,
        // timeout: Number,
        // goodsInfo: Object,
    },
    data() {
        return {
            popupShow: false,
            showKeyboard: true,
            code: "",

        
        };
    },
    components: {
        "van-popup": Popup,
        "van-password-input": PasswordInput,
        "van-number-keyboard": NumberKeyboard,
    },

    methods: {
        onSubmit(item) {
            this.$emit("onCodeSubmit", this.code);
        },

        
    },
    watch: {},
    created() {},
};
</script>

<style scoped lang="less">
.code-input {
}

.popup {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);

    // position: relative;

    .form {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        text-align: center;
        background: #fff;
        padding: 20px 0;
        margin: 10px;
        margin-top: 100px;
        position: relative;
        color: @main;

        .title {
            font-size: 16px;
            color: #333;
        }

        .tips {
            padding: 10px;
        }

        .close-btn {
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 1;
            color: #c8c9cc;
            font-size: 22px;
            cursor: pointer;
        }
    }

    .btn-wrap {
        display: flex;

        justify-content: space-between;
        align-items: center;
        .btn {
            width: 94%;
            line-height: 40px;

            background: @main;
            border-radius: 20px;

            text-align: center;
            color: #fff;
            display: flex;

            justify-content: center;
            align-items: center;
            margin: 15px 10px;
        }

        .btn-cancel {
            background: #fff;
            border-radius: 20px;
            border: 1px solid #ff991d;
            text-align: center;
            color: #ff991d;
        }
    }
}

.van-password-input__security li {
    font-size: 0.53333rem;
    line-height: 1.2;
    background-color: #eee;
}
</style>
